export default __webpack_public_path__ + "static/media/shared-earth-profile-icon-light.e1a03631.svg";